module.exports = __webpack_public_path__ + "img/conference_logo.2cc272fb.png";